<template>
  <section class="content">
    <v-layout justify-center>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex md12 xs12 sm12>
            <v-layout row wrap>
              <v-flex xs12 md2 sm6>
                <v-autocomplete
                  v-model="filter.campaignID"
                  item-value="id"
                  item-text="name"
                  :items="campaignFilterLists"
                  label="Campaign Filter"
                  hide-details
                  outlined
                  auto-select-first
                  @change="setFilterItems"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md2 sm6>
                <v-text-field
                  :hide-details="true"
                  v-model="filter.handle"
                  :height="56"
                  label="Filter by Handle"
                  outlined
                  v-on:keyup.enter="setFilterItems"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                md2
                sm6
              >
                <v-autocomplete
                  :hide-details="true"
                  item-text="name"
                  item-value="id"
                  v-model="filter.clientID"
                  :items="clientFilterLists"
                  :outlined="true"
                  label="Client"
                  auto-select-first
                  @change="setFilterItems"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                xs12
                md2
                sm6
              >
                <v-menu
                  ref="submissionDatePicker"
                  v-model="submissionDatePicker"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  dense
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Submission Date"
                      v-model="filter.filterDate"
                      readonly
                      clearable
                      outlined
                      hide-details="auto"
                      v-bind="attrs"
                      v-on="on"
                      @change="setFilterItems()"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filter.filterDate"
                    no-title
                    scrollable
                    range
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="secondary"
                        @click="cancelMonth()"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="secondary"
                        @click="searchMonthOk()"
                    >
                        OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex
                xs12
                md2
                sm6
              >
                <v-autocomplete
                  :hide-details="true"
                  item-text="text"
                  item-value="value"
                  v-model="filter.status"
                  :items="submissionStates"
                  :outlined="true"
                  label="Status"
                  auto-select-first
                  @change="setFilterItems"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md1 sm6>
                <v-btn @click="resetFilter" class="mt-2 primary">Reset</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md12 xs12 sm12>
            <v-data-table
              :headers="headers"
              :items="filteredItems"
              item-key="id"
              class="elevation-1"
            >
              <template v-slot:[`item.handle`]="{ item }">
                <social-handle
                  :isTikTok="item.platform === 'tiktok'"
                  :isInstagram="item.platform === 'instagram'"
                  :tiktokHandle="item.handle"
                  :instagramHandle="item.handle"
                />
              </template>
              <template v-slot:[`item.submissionDate`]="{ item }">
                <div style="min-width:70px">{{utils.formatCustomDate(item.submissionDate, 'DD/MM/YYYY')}}</div>
              </template>
              <template v-slot:[`item.stats`]="{ item }">
                <td class="text-xs-left">
                  <a :href="'/posts/internal/all-posts?handle='+item.handle+'&campaignID='+item.campaignID" target="_blank">{{item.stats}}</a>
                </td>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn color="primary" class="secondary--text" small :to="'/posts/internal/all-posts?handle='+item.handle+'&campaignID='+item.campaignID">
                  View Post&nbsp;<v-icon color="secondary" small>mdi-magnify</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    />
  </section>
</template>
<script>
import { mapState } from 'vuex';
import config from '@/config';
import campaignConfig from '../Campaign/config';
import postConfig from './postConfig';
import utils from '@/utils';
import SocialHandle from '../../scoped/custom/SocialHandle'
import campaignHelper from '../Campaign/campaignHelper';
import Loading from 'vue-loading-overlay';
export default {
  name: 'DraftSubmissionReport',
  components: {
    SocialHandle,
    Loading
  },
  data() {
    return {
      utils: utils.func,
      loading: false,
      filter: {
        handle: '',
        campaignIDs: [],
        campaignID: '',
        clientID: '',
        filterDate: [],
        status: ''
      },
      submissionDatePicker: false,
      submissionStates: postConfig.submissionStates,
      submissionState: postConfig.submissionState,
      postTypeDeliverables: postConfig.postTypeDeliverables,
      headers: [
        {
          'text': 'Campaign',
          'align': 'start',
          'value': 'campaignName',
          'sortable': false
        },
        {
          'text': 'Handle',
          'align': 'start',
          'value': 'handle',
          'sortable': false
        },
        {
          'text': 'Submission Date',
          'align': 'start',
          'value': 'submissionDate',
          'sortable': false
        },
        {
          'text': 'Deliverables',
          'align': 'start',
          'value': 'deliverables',
          'sortable': false
        },
        {
          'text': 'Produced Deliverables',
          'align': 'start',
          'value': 'producedDeliverables',
          'sortable': false
        },
        {
          'text': 'Stats',
          'align': 'start',
          'value': 'stats',
          'sortable': false
        },
        {
          'text': 'Action',
          'align': 'start',
          'value': 'action',
          'sortable': false
        }
      ],
      filteredItems: [],
      campaignFilterLists: [],
      clientFilterLists: []
    }
  },
  computed: {
    ...mapState({
      unsubmittedInfluencers: state => state.pairing.unsubmittedInfluencers,
      campaigns: state => state.campaign.campaigns,
      clients: state => state.client.clients,
      postDeliverables: state => state.post.strPostDeliverables,
      totalDeliverables: state => state.post.totalDeliverables
    }),
    currentUserID: function () {
      return this.$store.state.user.id
    }
  },
  async mounted() {
    if (this.$route.query.date) {
      this.filter.filterDate = this.$route.query.date
    }
    await this.refresh()
    this.beautifyData()
    this.setFilterItems()
    await this.getClients()
  },
  methods: {
    async setFilterItems() {
      if (this.filter.filterDate) {
        await this.refresh()
      }
      this.filteredItems = Object.assign([], this.unsubmittedInfluencers)
      if (this.filter.campaignID) {
        this.filteredItems = this.filteredItems.filter(item => item.campaignID === this.filter.campaignID)
      }
      if (this.filter.handle) {
        this.filteredItems = this.filteredItems.filter(item => item.handle === this.filter.handle)
      }
      if (this.filter.clientID) {
        this.filteredItems = this.filteredItems.filter(item => item.clientID === this.filter.clientID)
      }
      if (this.filter.status) {
        this.filteredItems = this.filteredItems.filter(item => {
          if (this.filter.status === this.submissionState.FULL && item.totalProducedDeliverables >= item.totalPairingDeliverables) {
            return true
          }
          if (this.filter.status === this.submissionState.PARTIAL && item.totalProducedDeliverables < item.totalPairingDeliverables) {
            return true
          }
          if (this.filter.status === this.submissionState.EMPTY && !item.totalProducedDeliverables) {
            return true
          }
          return false
        })
      }
    },
    beautifyData() {
      this.filteredItems = this.unsubmittedInfluencers.map(inf => {
        let campaign = this.campaigns.find(c => c.id === inf.campaignID)
        if (campaign) {
          inf.clientID = campaign.clientID
          inf.campaignName = campaign.name
        }
        inf.deliverables = campaignHelper.getDeliverableDetails(inf.deliverableDetails)
        inf.totalPairingDeliverables = campaignHelper.getTotalDeliverables(Object.assign([], inf.deliverableDetails))
        if (inf.posts.length > 0) {
          let infPosts = inf.posts.filter(post => post.campaignID === inf.campaignID)
          this.$store.dispatch('post/setPostDeliverables', infPosts)
          inf.producedDeliverables = this.postDeliverables
          inf.totalProducedDeliverables = this.totalDeliverables
        }
        inf.stats = `${inf.totalProducedDeliverables || 0} / ${inf.totalPairingDeliverables}`
        return inf
      })
    },
    async getDraftSubmissions() {
      await this.$store.dispatch('pairing/getPostUnsubmittedPairingInfluencers', this.filter)
    },
    async getCampaigns() {
      let filter = {
        statuses: [
          config.campaignStatus.PAIRING_INFLUENCER,
          config.campaignStatus.ONGOING,
          config.campaignStatus.REVIEW
        ],
        type: campaignConfig.campaignType.STORY_TELL
      }
      await this.$store.dispatch('campaign/getCampaigns', filter)
      this.campaignFilterLists = [{id: '', name: 'All Campaigns'}, ...this.campaigns]
    },
    async refresh() {
      this.loading = true
      await this.getCampaigns()
      this.filter.campaignIDs = this.campaigns.map(campaign => campaign.id)
      await this.getDraftSubmissions()
      this.loading = false
      this.beautifyData()
    },
    async resetFilter() {
      this.filter = {
        handle: '',
        campaignID: '',
        clientID: '',
        filterDate: [],
        status: ''
      }
      await this.refresh()
    },
    async cancelMonth() {
      this.submissionDatePicker = false
      this.filter.filterDate = []
      await this.refresh()
    },
    async searchMonthOk() {
      this.submissionDatePicker = false
      await this.refresh()
    },
    async getClients() {
      await this.$store.dispatch('client/getClients')
      let clientIDs = [...new Set(this.campaigns.map(c => c.clientID))]
      this.clientFilterLists = this.clients.filter(b => clientIDs.includes(b.id))
      this.clientFilterLists.unshift({id: '', name: 'All Clients'})
    }
    // openSubmittedPostView(handle) {
    //   this.$router.push({ path: '/posts/internal/pending-kobe', query: { handle } });
    // }
  }
}
</script>



// WEBPACK FOOTER //
// DraftSubmissionReport.vue?7aa35e32